module.exports = __webpack_public_path__ + "img/renke-1.d0678d9c.png";